import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion as m } from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {MdEmail} from 'react-icons/md';
import {BsMessenger} from 'react-icons/bs';
import {IoLogoWhatsapp} from 'react-icons/io';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './contact.css';

const Contact = () => {
    useEffect(() => { AOS.init({ once: true }); }, []);

    const sendEmail = async (e) => {
        e.preventDefault();
        const form = e.target;
        const name = form.name.value.trim();
        const email = form.email.value.trim();
        const message = form.message.value.trim();

        if (!name || !email || !message) {
        alert('Please fill all fields.');
        return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
        alert('Please enter a valid email.');
        return;
        }

        const payload = { name, email, message };

        try {
        const res = await fetch('https://pestexmasters.co.ke/send_email.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        const json = await res.json();
        if (res.ok && json.ok) {
            alert('Message sent — thank you!');
            form.reset();
        } else {
            console.error('Send failed:', json);
            alert('Send failed: ' + (json.error || 'server error'));
        }
        } catch (err) {
        console.error('Network error:', err);
        alert('Network/error: ' + err.message);
        }
    };

    return (
        <m.div
        initial={{x: "-100%"}}
        animate={{x: "-0%"}}
        transition={{ duration: 0.9, delay:0.7}}
        exit={{opacity: 1}}
        >
        <ScrollToTop />
        <PageHeader title="Contact" image={PageHeaderImage}>
            <p>
            <Link to="/">Home</Link> / Contact
            </p>
        </PageHeader>

        <section className="contact">
            <div className="container contact_container">
            <div className="form_wrapper">
                <h4>Get In Touch</h4>
                <form onSubmit={sendEmail}>
                <input type="text" name="name" placeholder="Your full name" required />
                <input type="email" name="email" placeholder="Your Email" required />
                <textarea name="message" cols="30" rows="10" placeholder="Your Message" required></textarea>
                <button type="submit" className="btn lg contact_form_btn">Send Message</button>
                </form>
            </div>

            <div className="contact_wrapper">
                <div className="contact_wrapper_contents">
                <a href="mailto:info@pestexmasters.co.ke" target="_blank" rel="noreferrer noopener">
                    <MdEmail/>
                </a>
                <p>Email Us</p>
                </div>
                <div className="contact_wrapper_contents">
                <a href="https://m.me/pestexmasters" target="_blank" rel="noreferrer noopener">
                    <BsMessenger/>
                </a>
                <p>Messenger</p>
                </div>
                <div className="contact_wrapper_contents">
                <a href="https://wa.me/+254708746461" target="_blank" rel="noreferrer noopener">
                    <IoLogoWhatsapp/>
                </a>
                <p>WhatsApp Us</p>
                </div>
                <div/>
            </div>

            <div className="contact_map_container">
                <h4>Location</h4>
                <iframe data-aos="fade-up" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.846744366707!2d36.82161407423282!3d-1.2644692356011247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f17201a22d1a9%3A0x436e9081ebbcfe04!2sPark%20Place%20Business%20Center!5e0!3m2!1sen!2ske!4v1690196929216!5m2!1sen!2ske" width="100%" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Location"></iframe>
            </div>
            </div>
        </section>
        </m.div>
    );
};

export default Contact;